import { noop } from 'lodash';
import React from 'react';
import type { BulkManagementTableModalKey, FundToBulkProxy } from 'venn-components';

type SingleProxyPickerContextType = {
  open: (key: BulkManagementTableModalKey, investment: FundToBulkProxy) => void;
};
const defaultContextValue: SingleProxyPickerContextType = {
  open: noop,
};
export const SingleProxyPickerContext = React.createContext(defaultContextValue);

SingleProxyPickerContext.displayName = 'SingleProxyPickerContext';
